import debug from "debug";

const log = debug("Utils");

class Utils {
	// Merges two JavaScript objects
	Extend(obj, src) {
		Object.keys(src).forEach(function (key) {
			obj[key] = src[key];
		});
		return obj;
	}

	// Removes all line breaks in text
	RemoveLinebreaks(text) {
		return text.replace(/[\r\n]+/gm, "");
	}

	/**
	 * Trims all whitespace longer than 1 space
	 * @param {*} text 
	 * @returns 
	 * 
	 * @deprecated use native JS: string.trim()
	 */
	TrimExcessWhitespace(text) {
		return text.replace(/\s{2,}/g, "");
	}

	/**
	 * @param {string} text
	 *
	 * @returns {boolean}
	 */
	IsNullOrWhiteSpace(text) {
		if (text === null) return true;
		if (text === undefined) return true;
		if (text === "") return true;

		return false;
	}

	RemoveArrayCommas(array) {
		return array.join(" ");
	}

	// Duplicate elements in an array nth times
	// when there is a small dataset
	///// Example
	///// const allItems = duplicateArrayElements(
	///// 	this.dataset.dataset.$values,
	///// 	3
	///// ).sort((a, b) => a.id - b.id);
	DuplicateArrayElements = (array, n) => {
		// Create an array of size "n" with undefined values
		var arrays = Array.apply(null, new Array(n));

		// Replace each "undefined" with our array, resulting in an array of n copies of our array
		arrays = arrays.map(function () {
			return array;
		});

		// Flatten our array of arrays
		return [].concat.apply([], arrays);
	};
}

export default Utils;
